import { LoadingOutlined } from "@ant-design/icons";
import { TableColumnsType, Tooltip } from "antd";

import { permissions } from "@router";
import { IIndustry, ISubIndustry } from "@types";
import { checkPermission } from "@utils";

export const getColumns = ({
  isDeleting,
  industry_id,
  editIndustry,
  handleDeleteIndustry,
}: {
  isDeleting: boolean;
  industry_id: React.MutableRefObject<any>;
  editIndustry: (
    industry: IIndustry,
    event: React.MouseEvent<HTMLDivElement, MouseEvent>
  ) => void;
  handleDeleteIndustry: (
    id: number,
    event: React.MouseEvent<HTMLDivElement, MouseEvent>
  ) => Promise<void>;
}) => {
  const columns: TableColumnsType<IIndustry> = [
    {
      title: "Industry",
      dataIndex: "name",
      key: "industry",
      width: `30%`,
      render: (name: string) => <div className="text-wrap">{name}</div>,
    },
    {
      title: "Sub-Industry",
      dataIndex: "sub_industries",
      key: "subIndustry",
      width: `70%`,
      render: (sub_industries: ISubIndustry[]) => {
        if (!sub_industries?.length) return null;

        const names = sub_industries.map(
          (sub_industry: ISubIndustry) => sub_industry.name
        );

        const visibleCount = 2;
        const remaining = names.length - visibleCount;

        return (
          <Tooltip title={names.join(", ")}>
            <span>
              {names.slice(0, visibleCount).join(", ")}
              {remaining > 0 && (
                <span className="text-blue-500 text-center text-xs font-semibold mx-2">
                  {" ... "}+{remaining}
                </span>
              )}
            </span>
          </Tooltip>
        );
      },
    },
    ...((!checkPermission([
      permissions.UPDATE_INDUSTRY,
      permissions.DELETE_INDUSTRY,
    ])
      ? []
      : [
          {
            title: "Actions",
            key: "action",
            width: 160,
            align: "center",
            render: (industry: IIndustry) => (
              <div className="flex items-center gap-2">
                {checkPermission(permissions.UPDATE_INDUSTRY) && (
                  <div
                    onClick={event => editIndustry(industry, event)}
                    className="table__action__btn table__action__btn--client"
                  >
                    Edit
                  </div>
                )}

                {checkPermission(permissions.DELETE_INDUSTRY) && (
                  <div
                    onClick={event => handleDeleteIndustry(industry.id, event)}
                    className="table__action__btn table__action__btn--delete"
                  >
                    {isDeleting && industry.id === industry_id.current ? (
                      <LoadingOutlined className="spinner" />
                    ) : (
                      "Delete"
                    )}
                  </div>
                )}
              </div>
            ),
          },
        ])! as any),
  ];
  return columns;
};
